import { Navigate, useLocation } from 'react-router-dom';
import { WEB_ROUTES } from '@wonderherbals/shared';
import { useAuthStore } from '../stores/useAuthStore';
import { PageLoader } from './LoadingSpinner';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
    const { session, isInitialized, isLoading } = useAuthStore();
    const location = useLocation();

    if (!isInitialized || isLoading) {
        return <PageLoader />;
    }

    if (!session) {
        return <Navigate to={WEB_ROUTES.LOGIN} state={{ from: location }} replace />;
    }

    return <>{children}</>;
}
